import React from 'react';
import MedicalCalendar from '../components/MedicalCalendar';
import MainLayout from '../components/MainLayout';

const Calendar = () => {
  return (
    <MainLayout>
      <MedicalCalendar />
    </MainLayout>
  );
};

export default Calendar;
